// Copyright (c) 2025 WiseTime. All rights reserved.

import { combineEpics } from "redux-observable"
import { Action } from "redux"
import type { RootState } from "../../../app/store"
import listTimesheetFieldOptions from "./listTimesheetFieldOptions"
import generateTimesheetFieldConfigs from "./generateTimesheetFieldConfigs"
import batchGetTimesheetFieldConfigs from "./batchGetTimesheetFieldConfigs"
import createTimesheetField from "./createTimesheetField"
import updateTimesheetField from "./updateTimesheetField"
import deleteTimesheetField from "./deleteTimesheetField"
import createTimesheetFieldOption from "./createTimesheetFieldOption"
import updateTimesheetFieldOption from "./updateTimesheetFieldOption"
import deleteTimesheetFieldOption from "./deleteTimesheetFieldOption"
import enableTimesheetFieldOptions from "./enableTimesheetFieldOptions"
import disableTimesheetFieldOptions from "./disableTimesheetFieldOptions"

export default combineEpics<Action, Action, RootState, unknown>(
  listTimesheetFieldOptions,
  generateTimesheetFieldConfigs,
  batchGetTimesheetFieldConfigs,
  createTimesheetField,
  updateTimesheetField,
  deleteTimesheetField,
  createTimesheetFieldOption,
  updateTimesheetFieldOption,
  deleteTimesheetFieldOption,
  enableTimesheetFieldOptions,
  disableTimesheetFieldOptions,
)
